module.exports = __webpack_public_path__ + "img/indus-pic-11.ebc303b6.png";